<template>
  <exportTemplate
    ref="exportTemplate"
    :showExport="false"
    :showCustomColumns="false"
    placement="top"
    :formModel="formModel"
    :table-data="tableList"
    :table-total="paginationTotal"
    :table-load="tableLoading"
    @pagination-change="paginationChange"
    @form-submit="formSubmit"
    @form-reset="formReset"
    @sort="sortChange"
    @row-dblclick="rowDblclick"
  >
    <template #form>
      <el-form-item label="企业名" prop="enterpriseName">
        <el-input
          placeholder="请输入企业名模糊查询"
          v-model="formModel.enterpriseName"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input
          placeholder="请输入电话精确查询"
          v-model="formModel.phone"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="老板名称" prop="boss">
        <el-input
          placeholder="请输入老板名称模糊查询"
          v-model="formModel.boss"
          clearable
        ></el-input>
      </el-form-item>
    </template>
    <template>
      <el-table-column
        label="企业"
        prop="enterpriseName"
        width="170"
        fixed
      ></el-table-column>
      <el-table-column
        label="联系电话"
        prop="phone"
        width="170"
      ></el-table-column>
      <el-table-column
        label="所属服务器"
        prop="applicationServerID"
        width="100"
      ></el-table-column>
      <el-table-column label="负责人" prop="boss" width="150"></el-table-column>
      <el-table-column
        label="默认登录账号"
        prop="superUserName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="手机端口数"
        prop="mobileMaxUser"
        width="80"
      ></el-table-column>
      <el-table-column
        label="企业地址"
        prop="enterpriseAddress"
        width="120"
      ></el-table-column>
      <el-table-column label="推荐人" prop="referrerName" width="100"></el-table-column>
      <el-table-column label="推荐人电话" prop="referrerPhone" width="100"></el-table-column>
      <el-table-column
        label="所属业务员"
        prop="salesManName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="所属渠道"
        prop="channelManName"
        width="120"
      ></el-table-column>
      <el-table-column label="相关操作" prop="monthQty" width="430" fixed="right">
        <template #default="{ row }">
          <div class="action-btns">
            <el-button type="primary" @click="showPortraitDialog(row)" size="mini"
              >用户画像</el-button
            >
            <el-button type="success" @click="showPlugins(row)" size="mini"
              >插件管理</el-button
            >
            <el-button @click="showVersion(row)" size="mini"
              >版本详情</el-button
            >
            <!-- v0.0.224 选品开关：维护访销/综合单选品功能开关（周期动销门店数/销量/商品次数、最近下单） -->
            <el-button type="warning" @click="showItemListFeatureConfig(row)" size="mini"
              >选品开关</el-button
            >
            <el-button v-if="row.isXSLWMS == 'Y'" type="danger" @click="showWmsBindDialog(row)" size="mini"
              >库房绑定</el-button
            >
          </div>
        </template>
      </el-table-column>
    </template>
    <el-dialog
        title="用户画像"
        :visible.sync="portraitDialogVisible"
        @closed="portraitDialogClose"
        append-to-body :close-on-click-modal="false"
        width="70%">
      <template>
        <portrait v-if="portraitDialogVisible" :portrait-prop-data="portraitPropData"></portrait>
      </template>
    </el-dialog>
    <el-dialog
        title="插件管理"
        :visible.sync="pluginsDialogVisible"
        @closed="pluginsDialogClose"
        append-to-body :close-on-click-modal="false"
        width="70%">
      <template>
        <plugins v-if="pluginsDialogVisible" :plugins-prop-data="pluginsPropData"></plugins>
      </template>
    </el-dialog>
    <el-dialog
        title="版本详情"
        :visible.sync="versionDialogVisible"
        @closed="versionDialogClose"
        append-to-body :close-on-click-modal="false"
        width="70%">
      <template>
        <version v-if="versionDialogVisible" :version-prop-data="versionPropData"></version>
      </template>
    </el-dialog>
    <!-- v0.0.224 录单选品配置弹窗：四项 Y/N 开关 -->
    <el-dialog
        :title="'录单选品配置 — ' + (itemListFeatureConfigPropData.enterpriseName || '')"
        :visible.sync="itemListFeatureConfigDialogVisible"
        append-to-body :close-on-click-modal="false"
        width="420px">
      <el-form :model="itemListFeatureConfigForm" label-width="150px" v-loading="itemListFeatureConfigLoading">
        <el-form-item label="周期动销门店数">
          <el-switch v-model="itemListFeatureConfigForm.fiveWeekStoreCount"
            active-value="Y" inactive-value="N"></el-switch>
        </el-form-item>
        <el-form-item label="周期动销销量">
          <el-switch v-model="itemListFeatureConfigForm.fiveWeekSaleQtyText"
            active-value="Y" inactive-value="N"></el-switch>
        </el-form-item>
        <el-form-item label="周期动销商品次数">
          <el-switch v-model="itemListFeatureConfigForm.fiveWeekSaleCount"
            active-value="Y" inactive-value="N"></el-switch>
        </el-form-item>
        <el-form-item label="最近下单">
          <el-switch v-model="itemListFeatureConfigForm.lastOrderDateText"
            active-value="Y" inactive-value="N"></el-switch>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="itemListFeatureConfigDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="itemListFeatureConfigSaving" @click="saveItemListFeatureConfig">保存</el-button>
      </template>
    </el-dialog>
    <el-dialog
        :title="'库房绑定 — ' + (wmsBindPropData.enterpriseName || '')"
        :visible.sync="wmsBindDialogVisible"
        append-to-body :close-on-click-modal="false"
        width="760px">
      <el-table :data="wmsBindList" v-loading="wmsBindLoading" stripe border max-height="420">
        <el-table-column prop="warehouseName" label="库房名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="warehouseTypeStr" label="库房类型" width="100"></el-table-column>
        <el-table-column label="WMS绑定" min-width="160" show-overflow-tooltip>
          <template #default="{ row }">
            {{ wmsBindLabel(row) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template #default="{ row }">
            <el-button v-if="row.warehouseType != 'C' && !isWmsBound(row)" type="text" @click="openBindWms(row)">绑定</el-button>
            <el-button v-if="row.warehouseType != 'C' && isWmsBound(row)" type="text" @click="unbindWms(row)">解绑</el-button>
            <el-button v-if="row.warehouseType == 'C' && !isWmsVehicleBound(row)" type="text" @click="openBindWmsVehicle(row)">绑定车辆</el-button>
            <el-button v-if="row.warehouseType == 'C' && isWmsVehicleBound(row)" type="text" @click="unbindWmsVehicle(row)">解绑车辆</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
        :title="bindWmsForm.bindType === 'vehicle' ? '绑定WMS车辆' : '绑定WMS库房'"
        :visible.sync="bindWmsDialogVisible"
        append-to-body :close-on-click-modal="false"
        width="480px">
      <div style="margin-bottom: 16px;color: #606266;">ERP库房：{{ bindWmsForm.warehouseName }}</div>
      <el-form size="small" label-width="110px">
        <el-form-item v-if="bindWmsForm.bindType !== 'vehicle'" label="WMS库房" required>
          <el-input v-model="bindWmsForm.wmsID" clearable placeholder="请输入WMS库房编码"></el-input>
        </el-form-item>
        <el-form-item v-else label="WMS车辆" required>
          <el-input v-model="bindWmsForm.wmsVehicleID" clearable placeholder="请输入WMS车辆编码"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="bindWmsDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="bindWmsLoading" @click="submitBindWms">确定</el-button>
      </template>
    </el-dialog>
  </exportTemplate>
</template>

<script>
import exportTemplate from "@/components/common/exportTemplate.vue";
import portrait from "@/components/monitorCenter/portrait.vue";
import plugins from "@/components/monitorCenter/plugins.vue";
import version from "@/components/monitorCenter/version.vue";
export default {
  name: "mainAccount",
  components: {
    exportTemplate,
    portrait,
    plugins,
    version
  },
  data() {
    return {
      params: {
        enterpriseName: "",
        boss: "",
        phone: "",
        page: 1,
        size: 20
      },
      formModel: {
        enterpriseName: "",
        boss: "",
        phone: "",
      },
      paginationTotal: 0,
      tableList: [],
      tableLoading: false,

      portraitPropData: {},
			portraitDialogVisible: false,

      pluginsPropData: {},
      pluginsDialogVisible: false,

      versionPropData: {},
      versionDialogVisible: false,

      // v0.0.224 录单选品配置（选品开关）
      itemListFeatureConfigPropData: {},       // 当前行（含 enterpriseCode/enterpriseName）
      itemListFeatureConfigDialogVisible: false,
      itemListFeatureConfigLoading: false,     // 读取中
      itemListFeatureConfigSaving: false,      // 保存中
      itemListFeatureConfigForm: {
        fiveWeekStoreCount: "N",
        fiveWeekSaleQtyText: "N",
        fiveWeekSaleCount: "N",
        lastOrderDateText: "N",
      },

      wmsBindPropData: {},
      wmsBindDialogVisible: false,
      wmsBindLoading: false,
      wmsBindList: [],
      bindWmsDialogVisible: false,
      bindWmsLoading: false,
      bindWmsForm: {
        warehouseID: "",
        warehouseName: "",
        wmsID: "",
        wmsVehicleID: "",
        bindType: "warehouse",
      },
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    paginationChange({ page, size, isGetTable = true }) {
      this.params.page = page;
      this.params.size = size;
      if (isGetTable) {
        this.getTableList();
      }
    },
    formSubmit() {
      this.params = { ...this.params, ...this.formModel };
      this.getTableList();
    },
    formReset() {
      this.params["sortField"] = "";
      this.params["softBy"] = "";
      this.params.page = 1;
    },
    async getTableList() {
      this.tableLoading = true;
      this.tableData = [];
      const { data: res } = await this.$http.post(
        "/Account/monitorCenterEnterDefine/selectEnterByCondition.html",
        this.Qs.stringify(this.params)
      );
      this.tableLoading = false;
      if (res.code != "success") return this.$message.error(res.message);
      let { data, total } = JSON.parse(res.result);
      this.paginationTotal = total;
      this.tableList = JSON.parse(data);
      console.log(JSON.parse(data));
    },
    sortChange({ sortField, sortBy }) {
      this.params["sortField"] = sortField;
      this.params["sortBy"] = sortBy;
      this.params.page = 1;
      this.getTableList();
    },
    rowDblclick({ row }) {
      console.log(row);
    },
    portraitDialogClose() {
      this.portraitDialogVisible = false
    },
    showPortraitDialog(row) {
      this.portraitPropData = row
      this.portraitDialogVisible = true
    },
    pluginsDialogClose() {
      this.pluginsDialogVisible = false
    },
    showPlugins(row) {
      this.pluginsPropData = row
      this.pluginsDialogVisible = true
      console.log(row)
    },
    showVersion(row) {
      this.versionPropData = row
      this.versionDialogVisible = true
    },
    versionDialogClose() {
      this.versionDialogVisible = false
    },
    // v0.0.224 选品开关：打开弹窗并读取当前企业四项配置
    async showItemListFeatureConfig(row) {
      this.itemListFeatureConfigPropData = row;
      this.itemListFeatureConfigDialogVisible = true;
      this.itemListFeatureConfigLoading = true;
      // 重置为默认 N，避免上次残留
      this.itemListFeatureConfigForm = {
        fiveWeekStoreCount: "N",
        fiveWeekSaleQtyText: "N",
        fiveWeekSaleCount: "N",
        lastOrderDateText: "N",
      };
      try {
        const { data: res } = await this.$http.post(
          "/Account/monitorCenterEnterDefine/selectItemListFeatureConfig.html",
          this.Qs.stringify({ enterpriseCode: row.enterpriseCode })
        );
        if (res.code != "success") {
          this.$message.error(res.message || "查询失败");
          return;
        }
        const cfg = JSON.parse(res.result);
        this.itemListFeatureConfigForm = {
          fiveWeekStoreCount: cfg.fiveWeekStoreCount === "Y" ? "Y" : "N",
          fiveWeekSaleQtyText: cfg.fiveWeekSaleQtyText === "Y" ? "Y" : "N",
          fiveWeekSaleCount: cfg.fiveWeekSaleCount === "Y" ? "Y" : "N",
          lastOrderDateText: cfg.lastOrderDateText === "Y" ? "Y" : "N",
        };
      } catch (e) {
        this.$message.error("查询选品开关失败");
      } finally {
        this.itemListFeatureConfigLoading = false;
      }
    },
    // v0.0.224 选品开关：保存四项配置（切企业中心库 upsert）
    async saveItemListFeatureConfig() {
      this.itemListFeatureConfigSaving = true;
      try {
        const params = {
          enterpriseCode: this.itemListFeatureConfigPropData.enterpriseCode,
          fiveWeekStoreCount: this.itemListFeatureConfigForm.fiveWeekStoreCount,
          fiveWeekSaleQtyText: this.itemListFeatureConfigForm.fiveWeekSaleQtyText,
          fiveWeekSaleCount: this.itemListFeatureConfigForm.fiveWeekSaleCount,
          lastOrderDateText: this.itemListFeatureConfigForm.lastOrderDateText,
        };
        const { data: res } = await this.$http.post(
          "/Account/monitorCenterEnterDefine/saveItemListFeatureConfig.html",
          this.Qs.stringify(params)
        );
        if (res.code != "success") {
          this.$message.error(res.message || "保存失败");
          return;
        }
        this.$message.success("保存成功");
        this.itemListFeatureConfigDialogVisible = false;
      } catch (e) {
        this.$message.error("保存选品开关失败");
      } finally {
        this.itemListFeatureConfigSaving = false;
      }
    },
    isWmsBound(row) {
      return !!(row && row.wmsID && String(row.wmsID).trim());
    },
    erpWmsBindUrl(path) {
      return "/erpnew/account/c/reada46ceb/erpWmsIntegration/" + path;
    },
    isErpNewOk(res) {
      return !!(res && (res.code == 200 || res.code == 0 || res.code === "200" || res.code === "0"
        || res.success === true
        || (res.data && (res.data.success === true || res.data.code == 200 || res.data.code == 0))));
    },
    erpNewMessage(res, fallback) {
      if (!res) return fallback;
      return res.message || (res.data && res.data.message) || fallback;
    },
    async postErpWmsBind(path, body, failText) {
      try {
        const { data: res } = await this.$http.post(this.erpWmsBindUrl(path), body, {
          headers: { "Content-Type": "application/json;charset=utf-8" },
        });
        if (this.isErpNewOk(res)) {
          return { ok: true, message: this.erpNewMessage(res, "操作成功") };
        }
        return { ok: false, message: this.erpNewMessage(res, failText) };
      } catch (e) {
        const res = e && e.response && e.response.data;
        return { ok: false, message: this.erpNewMessage(res, failText) };
      }
    },
    isWmsVehicleBound(row) {
      return !!(row && row.wmsVehicleID && String(row.wmsVehicleID).trim());
    },
    wmsBindLabel(row) {
      if (row && row.warehouseType == "C") {
        return this.isWmsVehicleBound(row) ? ("车辆 " + row.wmsVehicleID) : "未绑定";
      }
      return this.isWmsBound(row) ? row.wmsID : "未绑定";
    },
    async showWmsBindDialog(row) {
      if (row.isXSLWMS != "Y") {
        return this.$message.warning("未开启系统 WMS，无需绑定");
      }
      this.wmsBindPropData = row;
      this.wmsBindDialogVisible = true;
      await this.loadWmsBindList();
    },
    async loadWmsBindList() {
      this.wmsBindLoading = true;
      this.wmsBindList = [];
      try {
        const { data: res } = await this.$http.post(
          "/Account/monitorCenterEnterDefine/selectEnterpriseWarehousesForWms.html",
          this.Qs.stringify({ enterpriseCode: this.wmsBindPropData.enterpriseCode })
        );
        if (res.code != "success") {
          this.$message.error(res.message || "查询库房失败");
          return;
        }
        const parsed = JSON.parse(res.result || "{}");
        this.wmsBindList = JSON.parse(parsed.data || "[]");
      } catch (e) {
        this.$message.error("查询库房失败");
      } finally {
        this.wmsBindLoading = false;
      }
    },
    openBindWms(row) {
      if (row.warehouseType == "C") {
        return this.$message.warning("车辆虚拟库不能绑定 WMS");
      }
      this.bindWmsForm = {
        warehouseID: row.warehouseID || row.id,
        warehouseName: row.warehouseName,
        wmsID: "",
        wmsVehicleID: "",
        bindType: "warehouse",
      };
      this.bindWmsDialogVisible = true;
    },
    openBindWmsVehicle(row) {
      this.bindWmsForm = {
        warehouseID: row.warehouseID || row.id,
        warehouseName: row.warehouseName,
        wmsID: "",
        wmsVehicleID: "",
        bindType: "vehicle",
      };
      this.bindWmsDialogVisible = true;
    },
    async submitBindWms() {
      if (this.bindWmsForm.bindType === "vehicle") {
        if (!this.bindWmsForm.wmsVehicleID || !String(this.bindWmsForm.wmsVehicleID).trim()) {
          return this.$message.warning("请输入 WMS 车辆编码");
        }
        this.bindWmsLoading = true;
        try {
          const result = await this.postErpWmsBind(
            "vehicles/bind",
            {
              warehouseId: this.bindWmsForm.warehouseID,
              wmsVehicleCode: String(this.bindWmsForm.wmsVehicleID).trim(),
              enterpriseCode: this.wmsBindPropData.enterpriseCode,
            },
            "绑定失败"
          );
          if (!result.ok) {
            this.$message.error(result.message);
            return;
          }
          this.$message.success(result.message);
          this.bindWmsDialogVisible = false;
          await this.loadWmsBindList();
        } finally {
          this.bindWmsLoading = false;
        }
        return;
      }
      if (!this.bindWmsForm.wmsID || !String(this.bindWmsForm.wmsID).trim()) {
        return this.$message.warning("请输入 WMS 库房编码");
      }
      this.bindWmsLoading = true;
      try {
        const result = await this.postErpWmsBind(
          "warehouses/bind",
          {
            warehouseId: this.bindWmsForm.warehouseID,
            wmsWarehouseCode: String(this.bindWmsForm.wmsID).trim(),
            enterpriseCode: this.wmsBindPropData.enterpriseCode,
          },
          "绑定失败"
        );
        if (!result.ok) {
          this.$message.error(result.message);
          return;
        }
        this.$message.success(result.message);
        this.bindWmsDialogVisible = false;
        await this.loadWmsBindList();
      } finally {
        this.bindWmsLoading = false;
      }
    },
    async unbindWms(row) {
      try {
        await this.$confirm(
          "解绑后该库房将不再走系统 WMS。有在途访销出库或采购入库计划时不能解绑，是否继续？",
          "解绑WMS库房",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        );
      } catch (e) {
        return;
      }
      try {
        const result = await this.postErpWmsBind(
          "warehouses/unbind",
          {
            warehouseId: row.warehouseID || row.id,
            enterpriseCode: this.wmsBindPropData.enterpriseCode,
          },
          "解绑失败"
        );
        if (!result.ok) {
          this.$message.error(result.message);
          return;
        }
        this.$message.success(result.message);
        await this.loadWmsBindList();
      } catch (e) {
        this.$message.error("解绑失败");
      }
    },
    async unbindWmsVehicle(row) {
      try {
        await this.$confirm(
          "解绑后该车库将不再对应 WMS 车辆。有在途访销单据时不能解绑，是否继续？",
          "解绑WMS车辆",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        );
      } catch (e) {
        return;
      }
      try {
        const result = await this.postErpWmsBind(
          "vehicles/unbind",
          {
            warehouseId: row.warehouseID || row.id,
            enterpriseCode: this.wmsBindPropData.enterpriseCode,
          },
          "解绑失败"
        );
        if (!result.ok) {
          this.$message.error(result.message);
          return;
        }
        this.$message.success(result.message);
        await this.loadWmsBindList();
      } catch (e) {
        this.$message.error("解绑失败");
      }
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-dialog__body {
  padding-top: 0;
}
.action-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  ::v-deep .el-button + .el-button {
    margin-left: 0;
  }
}
</style>
